
export function getRandomAwarenessColor() {
  const hue = Math.floor(Math.random() * 360); // full color wheel
  const saturation = 65 + Math.random() * 20; // 65–85%
  const lightness = 55 + Math.random() * 10;  // 55–65%
  return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
}